// Function to update the free shipping progress bar
function updateFreeShippingBar(cartItemCount) {
    const message = document.getElementById("shipping-message");
    const progressBar = document.getElementById("progress-bar");
    const truckEmoji = document.getElementById("truck-emoji");

    if (cartItemCount >= 2) {
        message.textContent = "🎉 Hurray! You're Getting Up to 20% Off! 🔥";
        progressBar.style.width = "100%";
        truckEmoji.style.display = "inline-block"; // Show truck emoji
    } else if (cartItemCount === 1) {
        message.textContent = "Add One More Item & Unlock Up to 20% Off!";
        progressBar.style.width = "50%";
        truckEmoji.style.display = "none"; // Hide truck emoji
    } else {
        message.textContent = "Add items to get free shipping! 🛻";
        progressBar.style.width = "0%";
        truckEmoji.style.display = "none"; // Hide truck emoji
    }
}

// Function to fetch the updated cart and update the progress bar
function refreshCartData() {
    fetch('/cart.js') // Fetch updated cart data
        .then(response => response.json())
        .then(data => updateFreeShippingBar(data.item_count));
}

// Listen for Shopify's cart update event
window.addEventListener("theme:cart:updated", ({ detail: cart }) => {
    refreshCartData();
});

// Listen for quantity changes in the cart drawer
document.addEventListener("click", (event) => {
    if (event.target.matches(".quantity-selector--plus, .quantity-selector--minus")) {
        setTimeout(refreshCartData, 500); // Delay to allow Shopify to process the update
    }
});

// Listen for product variant updates (ensures updates on variant selection)
document.addEventListener("DOMContentLoaded", () => {
    const productId = "{{ product.id | append: '-' | section.id }}"; // Get product ID dynamically

    window.addEventListener(`theme:product:${productId}:variantUpdated`, ({ detail: { variant } }) => {
        refreshCartData();
    });

    // Initial cart check on page load
    refreshCartData();
});
